export default {"src":"/_next/static/media/STNE.50db11ba.svg","height":18,"width":18};